import { UpdateWebsiteDrawer } from './update-webisite-drawer.component';

export default UpdateWebsiteDrawer;
